import { render, staticRenderFns } from "./CompanyDetailIframeModal.vue?vue&type=template&id=2b445e38&"
import script from "./CompanyDetailIframeModal.vue?vue&type=script&lang=ts&"
export * from "./CompanyDetailIframeModal.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyDetailIframeModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports